import { render, staticRenderFns } from "./SummaryBlock.vue?vue&type=template&id=023d2004&scoped=true"
import script from "./SummaryBlock.vue?vue&type=script&lang=js"
export * from "./SummaryBlock.vue?vue&type=script&lang=js"
import style0 from "./SummaryBlock.vue?vue&type=style&index=0&id=023d2004&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023d2004",
  null
  
)

export default component.exports